import { createAction } from 'utils/reduxUtil';
import * as types from 'containers/registration/store/registrationActionTypes';

export const registrationReset = () => createAction(types.REGISTRATION_RESET);
